import styled from '@emotion/styled';
import { Box } from '@mantine/core';
import React, { useState } from 'react';

import { mediaQueryMobile } from '~/styles/mixins';

import { ParagraphMedium, TitleXSmall } from '../typography';

const Flex = styled(Box)`
  display: flex;
`;

const Root = styled(Box)`
  margin-top: -24px;
  transition: all 0.3s ease-in-out;
`;

const AccordionItem = styled(Box)`
  margin: 16px 0;
  padding: 24px;
  border-radius: 8px;
  background-color: ${(props) => (props.isOpen ? '#FAFAFA' : 'transparent')};
  cursor: pointer;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0px;
  }

  ${mediaQueryMobile} {
    padding: 16px;
    &:first-child {
      margin-top: 24px;
    }
  }
`;

const Header = styled(Flex)`
  justify-content: space-between;
  align-items: flex-start;
`;

const HeadingIcon = styled(Flex)`
  width: 32px;
  height: 32px;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 40px;
  margin-left: 12px;
`;

const IconHorizontal = styled(Box)`
  position: absolute;
  top: 50%;
  width: 8px;
  height: 1.5px;
  background-color: #616161;
`;

const IconVertical = styled(IconHorizontal)`
  opacity: ${(props) => (props.isOpen ? '0' : '1')};
  transform: ${(props) =>
    props.isOpen
      ? ''
      : 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(90deg) skew(0deg, 0deg)'};
  transform-style: preserve-3d;
`;

const Content = styled(ParagraphMedium)`
  margin-top: 16px;
  overflow: hidden;
  color: #626262;
  height: ${(props) => (props.isOpen ? 'auto' : '0px')};
`;

const FAQ = ({ items }) => {
  const [open, setIsOpen] = useState([]);
  const isOpen = (index) => (open.includes(index) ? true : false);

  const onToggle = (index) => {
    if (open.includes(index)) {
      setIsOpen(open.filter((item) => item !== index));
    } else {
      setIsOpen([[], index]);
    }
  };

  return (
    <Root>
      {items.map((item, index) => (
        <AccordionItem key={index} isOpen={isOpen(index)} onClick={() => onToggle(index)}>
          <Header>
            <TitleXSmall color="#434343">{item.question}</TitleXSmall>
            <HeadingIcon>
              <IconHorizontal />
              <IconVertical isOpen={isOpen(index)} />
            </HeadingIcon>
          </Header>
          <Content isOpen={isOpen(index)}>{item.response(item)}</Content>
        </AccordionItem>
      ))}
    </Root>
  );
};

export default FAQ;
